<div class="grid flex justify-content-center" [class]="onExtendedMobile() ? 'max-w-25rem' : 'max-w-33rem'">
  <div class="col-4 flex justify-content-center p-1" [class]="onExtendedMobile() ? '' : 'max-w-10rem'" *ngFor="let language of languages let i = index">
    <button pButton pRipple
      label="{{language.name}}" (click)="setLanguage(language);"
      class="font-normal border-round flex flex-column"
      [class]="onExtendedMobile() ? 'text-base w-7rem h-7rem py-4' : 'text-xl w-9rem h-9rem py-5'"
      [ngClass]="languageButtonColor(language)">
      <img src="{{ flagImagePath }}{{ language.code }}{{ flagImageFormat }}" alt="{{ language.name }}" [width]="onExtendedMobile() ? '30' : '50'" class="pb-2">
    </button>
  </div>
</div>
